/**
 * 判断是否server环境
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export var isServer = typeof window === 'undefined';
